module.exports = __webpack_public_path__ + "img/silvery-about.246f2ef.png";